import styled from "styled-components";
import { Input, Select } from "antd";

export const CustomInput = styled(Input)`
  width: 100%;
  height: 60px;
  margin: 10px 0px;
  font-size: 16px;
  color: black;
`;

export const CustomSelect = styled(Select)`
  width: 100%;
  height: 60px;
  margin: 10px 0px;
  font-size: 16px;
  color: black;

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const HskMessage = styled.div`
  text-align: left;
  margin: 4px 0px;
  font-size: 16px;
`;
